import { BaseSystemModel, Guid, RecursivePartial, SYSTEM_MODULE_IDS, VzSystemModule } from '@models/base';
import { VzParamOld } from '@models/params-old/param';

export class Integration extends BaseSystemModel {
    orgCreatedBy!: Guid;
    type!: string;
    title!: string;
    description?: string;
    avatar?: string;
    params?: VzParamOld[];
    filters?: VzParamOld[];
    modules?: { [moduleId in VzSystemModule]?: VzParamOld[] | null };

    constructor(json?: RecursivePartial<Integration>) {
        super(json);
        this.parseIntegration(json || {});
    }

    parse(json: RecursivePartial<Integration>): Integration {
        super.parse(json);
        this.parseIntegration(json);
        return this;
    }

    private parseIntegration(json: RecursivePartial<Integration>): void {
        Integration.assignFields(this, json, [
            'orgCreatedBy',
            'type',
            'title',
            'description',
            'avatar',
        ]);
        Integration.assignClassArrays(this, json, { params: VzParamOld, filters: VzParamOld });
        if (json.modules && typeof json.modules == 'object') {
            this.modules = {};
            for (const id of SYSTEM_MODULE_IDS) {
                if (json?.modules[id]) {
                    this.modules[id] = Integration.getClassArray<VzParamOld>(json.modules[id]!, VzParamOld);
                }
            }
        }
    }

}
